'use strict';
var $ = require('jquery');
var jqueryFormMask = require('jquery-mask-plugin');

function init() {
	// Setup fields now
	maskFields();

	// Setup fields if ajax takes place
	document.addEventListener('jsfAjaxEvent', function(event) {
		var extraData = event.detail;
		if (extraData.fireType == 'always') {
			maskFields();
		}
	});
}

function maskFields() {
	$('form input[type="tel"]').mask('(000) 000-0000', {
		placeholder: '(123) 456-7890'
	});

	$('form input[type="text"].money').mask("#,##0", {
		reverse: true,
		placeholder: '$'
	});

	$('form input[type="text"].digit').mask("#,##0", {
		reverse: true
	});

	$('form input[type="text"].percent').mask("N", {
		translation: {
			N:{pattern: /[0-9\.]/, recursive: true}
		},
		reverse: true,
		placeholder: '%'
	});

	$('form input[type="text"].year').mask("#,##0", {
		reverse: true
	});

}

module.exports = {
	init: init
};
